module.exports = __webpack_public_path__ + "static/team-10-2c867c42efec6c0bef9a5a43da5992a5.png";